import React from "react";
import BreadCrumb from "../../Common/BreadCrumb";
import { AreaChart, BarChart, LineChart, SimpleBarChart } from "./LineAreaBarSimple";
import { Barcharts, BasicDonughtChart, DoughnutChart, SplineChart } from "./BarSplineBasicDoughnut";

const ChartPage = () => {
  return (
    <React.Fragment>
      <BreadCrumb title="Chart" pageType="Sliced" />

      <div className="flex flex-col gap-4 min-h-[calc(100vh-212px)]">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-2">
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Line Chart
            </h2>
            <LineChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Area Chart
            </h2>
            <AreaChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Bar Chart
            </h2>
            <BarChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Simple Bar
            </h2>
            <SimpleBarChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Bar Chart
            </h2>
            <Barcharts />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Spline Area Charts
            </h2>
            <SplineChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Basic Donut
            </h2>
            <BasicDonughtChart />
          </div>
          <div className="p-5 bg-white border rounded border-black/10 dark:bg-darklight dark:border-darkborder">
            <h2 className="mb-4 text-base font-semibold text-black capitalize dark:text-white/80">
              Doughnut chart
            </h2>
            <DoughnutChart />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ChartPage;
